import * as fromDatatype from '../datatype-library';

export interface bl_inv_pdg_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    running_no: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    fi_category_group_guid_1:fromDatatype.GuidDataFieldInterface;
    fi_category_group_guid_2:fromDatatype.GuidDataFieldInterface;
    fi_category_group_guid_3:fromDatatype.GuidDataFieldInterface;
    fi_category_group_1_table_column: fromDatatype.VarcharDatatypeInterface;
    fi_category_group_2_table_column: fromDatatype.VarcharDatatypeInterface;
    fi_category_group_3_table_column: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    effective_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;     
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_inv_pdg_hdr_RowClass implements bl_inv_pdg_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    running_no: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    fi_category_group_guid_1:fromDatatype.GuidDataFieldInterface;
    fi_category_group_guid_2:fromDatatype.GuidDataFieldInterface;
    fi_category_group_guid_3:fromDatatype.GuidDataFieldInterface;
    fi_category_group_1_table_column: fromDatatype.VarcharDatatypeInterface;
    fi_category_group_2_table_column: fromDatatype.VarcharDatatypeInterface;
    fi_category_group_3_table_column: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    effective_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;     
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
